// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GE2k","colBig":"styles_colBig__1OgmD","colSmall":"styles_colSmall__i3YOL"};